module.exports = __webpack_public_path__ + "img/EARRINGS BN.647dddf.svg";